import { CURRENTY_ENUM, CURRENCY_STR } from "@/types/currency";

export const CURRENCY_SYMBOL_MAP = {
  [CURRENTY_ENUM.USDT]: '$',
  [CURRENTY_ENUM.INR]: '₹',
  [CURRENTY_ENUM.BRL]: 'R$',
};

export const CURRENCY_LABEL_MAP = {
  [CURRENTY_ENUM.USDT]: 'USDT',
  [CURRENTY_ENUM.INR]: 'INR',
  [CURRENTY_ENUM.BRL]: 'BRL',
};

export const CURRENCY_SHOW_MAP = {
  [CURRENCY_STR.USDT]: '₮',
  [CURRENCY_STR.INR]: '₹',
  [CURRENCY_STR.BRL]: 'R$',
};

export const CURRENCY_TYPE = {
  USDT: 'USDT',
  INR: 'INR',
  BRL: 'BRL',
}